import { focusRingStyles } from '../../../styles/focusRing';
import { tv } from '../../../utils/tv';

const menuItemBaseStyles = tv({
  base: [
    'col-span-3 grid grid-cols-subgrid items-center',
    'min-h-10 cursor-pointer px-4 py-2 text-inherit no-underline outline-none select-none',
    'hover:not-disabled:bg-neutral-muted-5-blank-hovered',
    'pressed:not-disabled:bg-neutral-muted-5-blank-pressed',
  ],
  variants: {
    isDisabled: {
      true: 'cursor-not-allowed disabled-foreground',
    },
  },
});

const menuItemFocusStyles = focusRingStyles({ position: 'inner' });

export { menuItemBaseStyles, menuItemFocusStyles };
